import React from "react";
import mockCss from "./Mock.module.css";

import { PlainModalOverlay } from "../UI/Modal/Modal";
import { LiaSchoolSolid } from "react-icons/lia";
import { GiTimeBomb } from "react-icons/gi";
import { LuInfo } from "react-icons/lu";
import { FaLongArrowAltLeft } from "react-icons/fa";
import { ButtonSubmitGreen } from "../UI/Buttons/Buttons";
import {
    formatTime,
    formatLargeText
} from "../../utils/client-functions";

const Rules = ({closeModalsAndReset, subject, handleStartExam, examName, description}) => {
    const examTime = subject?.timeAlloted || subject?.timeAllotted || 2700; // default 45 minutes
    return (
        <PlainModalOverlay>
            <div className='prev-page' onClick={closeModalsAndReset}>
                <FaLongArrowAltLeft />
            </div>
            <div className={mockCss.modalOverlayContainer}>
                <h2 className={mockCss.modalOverlayHeader}>
                    Mock Exam Rules
                </h2>
                <div className={mockCss.modalOverlaySub}>
                    <span>
                        {examName}
                    </span>
                </div>
                <div className={mockCss.modalOverlayCard}>
                    <div className={mockCss.modalOverlaySubjectRow}>
                        <LiaSchoolSolid style={{ color: '#3E8F93', fontSize: '1.5rem' }} />
                        <span style={{ fontWeight: 600, fontSize: '1rem', color: '#222' }}>{subject?.subject || subject?.level || subject?.subjectName || examName}</span>
                    </div>
                    <div className={mockCss.modalOverlaySubjectRow}>
                        <GiTimeBomb style={{ color: '#3E8F93', fontSize: '1.5rem' }} />
                        <span style={{ fontWeight: 600, fontSize: '1rem', color: '#222' }}>{formatTime(examTime)}</span>
                    </div>
                    <div className={mockCss.modalOverlaySubjectRow}>
                        <LuInfo style={{ color: '#3E8F93', fontSize: '1.4rem' }} />
                        <div style={{ fontSize: '.85rem', color: '#444', textAlign: 'left', width: '90%' }}>
                            {formatLargeText(subject?.description || description || subject?.topics + '\n\n' + subject?.rubric || '')}
                        </div>
                    </div>
                </div>
                <ul className={mockCss.modalOverlayList}>
                    <li className={mockCss.modalOverlayListItem}>
                        <span style={{ fontSize: '1.2rem' }}>📝</span>
                        Have a pencil and blank paper ready for each session
                    </li>
                    <li className={mockCss.modalOverlayListItem}>
                        <span style={{ fontSize: '1.2rem' }}>⏰</span>
                        All exams use real past questions, are time-based and will auto-close when time elapses
                    </li>
                    <li className={mockCss.modalOverlayListItem}>
                        <span style={{ fontSize: '1.2rem' }}>🔕</span>
                        Find a quiet, distraction-free place to take your exam
                    </li>
                    <li className={mockCss.modalOverlayListItem}>
                        <span style={{ fontSize: '1.2rem' }}>🚫</span>
                        Do not use external help—this affects your assessment and personalized plan
                    </li>
                    <li className={mockCss.modalOverlayListItem}>
                        <span style={{ fontSize: '1.2rem' }}>🚫</span>
                        Do NOT close window, leave tab or reload page, this will END your exam
                    </li>
                    <li className={mockCss.modalOverlayListItem}>
                        <span style={{ fontSize: '1.2rem' }}>📈</span>
                        Bubble Ai will grade, tutor you in weak areas, and curate a personalized study plan to help you focus only on what matters
                    </li>
                    <li className={mockCss.modalOverlayListItem}>
                        <span style={{ fontSize: '1.2rem' }}>🧘🏾‍♀️</span>
                        Finally, always BREATHE
                    </li>
                </ul>
                <div className={mockCss.modalOverlayStartBtn}>
                    <ButtonSubmitGreen type="button" onClick={handleStartExam}>
                        Generate Exam
                    </ButtonSubmitGreen>
                </div>
            </div>
        </PlainModalOverlay>
    );
}

export default Rules;